export const stringUtils = new (class StringUtils {
    /**
     * Returns a string with the first letter capitalized
     *
     */
    capitalizeFirstLetter(value) {
        return value && value[0].toUpperCase() + value.slice(1).toLowerCase();
    }
})();
